import { CONFIGURATION_FLAGS } from './configurationFlags';

export default defineAppConfig({
  clientHomePage: 'https://tigerairtw.com',

  features: CONFIGURATION_FLAGS,

  appearance: {
    destinationCard: {
      tagType: 'brand-primary',
    },
  },
});
